import { Link } from 'react-router-dom'
import { ShoppingBag } from 'lucide-react'
import type { Product } from '@server/db/schema'
import { formatPrice, toNumber } from '@/lib/money'
import { useCartStore } from '@/lib/cart'

export default function ProductCard({ product }: { product: Product }) {
  const addItem = useCartStore((s) => s.addItem)
  const compareAt = toNumber(product.compareAtPrice)
  const price = toNumber(product.price)
  const onSale = compareAt > price

  return (
    <article data-upbo-src="src/components/ProductCard.tsx:14" className="group flex flex-col overflow-hidden rounded-2xl border border-[#eedfda] bg-white transition-shadow hover:shadow-[0_12px_40px_-24px_rgba(122,79,69,0.55)]">
      <Link to={`/san-pham/${product.id}`} className="relative block aspect-[4/5] overflow-hidden bg-[#f7ebe7]">
        {product.image ? (
          <img data-upbo-src="src/components/ProductCard.tsx:17"
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div data-upbo-src="src/components/ProductCard.tsx:24" className="flex h-full w-full items-center justify-center text-sm text-[#c0a49d]">
            {product.name}
          </div>
        )}
        {onSale && (
          <span data-upbo-src="src/components/ProductCard.tsx:29" className="absolute left-3 top-3 rounded-full bg-[#c98b7e] px-3 py-1 text-[11px] font-medium text-white">
            Giảm giá
          </span>
        )}
      </Link>

      <div data-upbo-src="src/components/ProductCard.tsx:35" className="flex flex-1 flex-col gap-3 p-5">
        <Link to={`/san-pham/${product.id}`} className="text-sm font-medium text-[#5f3f38] hover:underline">
          {product.name}
        </Link>

        <div data-upbo-src="src/components/ProductCard.tsx:40" className="mt-auto flex items-center justify-between gap-3">
          <div data-upbo-src="src/components/ProductCard.tsx:41" className="flex items-baseline gap-2">
            <span data-upbo-src="src/components/ProductCard.tsx:42" className="text-base font-semibold text-[#7a4f45]">{formatPrice(product.price)}</span>
            {onSale && (
              <span data-upbo-src="src/components/ProductCard.tsx:44" className="text-xs text-[#c0a49d] line-through">{formatPrice(product.compareAtPrice)}</span>
            )}
          </div>

          <button data-upbo-src="src/components/ProductCard.tsx:48"
            type="button"
            onClick={() => addItem(product, 1)}
            aria-label={`Thêm ${product.name} vào giỏ`}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#7a4f45] text-white transition-colors hover:bg-[#63403a]"
          >
            <ShoppingBag className="h-4 w-4" />
          </button>
        </div>
      </div>
    </article>
  )
}
